import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import Anchor from '../utils/Anchor';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import { BLOCK_TYPE, blocksToComponents } from '../utils/Contentful';

const Wrapper = styled(Section)`
  background-color: ${props => props.backgroundColor || 'inherit'};
  padding-top: ${props => props.paddingTop || 'var(--default-vertical-padding)'};
  padding-bottom: ${props => props.paddingBottom || 'var(--default-vertical-padding)'};
  padding-left: var(--default-horizontal-padding);
  padding-right: var(--default-horizontal-padding);
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  > :not(:last-child) {
    margin-bottom: ${props => props.gap || '3rem'};
  }

  ${media.mediumLarge`
    flex-direction: row;
    align-items: stretch;

    > * {
      flex: 1;
    }

    > :not(:last-child) {
      margin-bottom: 0;
      margin-right: ${props => props.gap || '3rem'};
    }
  `}
`;

const ThreeColumnsBlock = ({ content }) => {
  const { title, textBlock, blocks, blockId, backgroundColor, gap, paddingTop, paddingBottom } =
    content;

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper
        backgroundColor={backgroundColor}
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
      >
        {get(textBlock, 'fields') && (
          <TextBlockWithIcon
            content={textBlock.fields}
            marginBottom="2rem"
            srcBlockName={`Three Columns Block - ${title}`}
          />
        )}
        {blocks && (
          <Column gap={gap}>
            {blocks.map(block =>
              blocksToComponents({
                block,
                src: BLOCK_TYPE.THREE_COLUMNS_BLOCK,
              })
            )}
          </Column>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

ThreeColumnsBlock.propTypes = {
  content: PropTypes.object,
};

export default ThreeColumnsBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/columnBlock/ThreeColumnsBlock.js